import styled from 'styled-components';

import {
    AUTH_PANEL_BLUE,
    AUTH_PANEL_MOBILE_WIDTH_PX,
    AUTH_PANEL_WIDTH_PX,
    AUTH_STACKED_LAYOUT_MAX_WIDTH_PX,
    AUTH_TAGLINE_WHITE,
    LOGIN_HERO_IMAGE,
} from '../../routes/auth/auth.tokens';

export const Panel = styled.div`
    position: relative;
    flex-shrink: 0;
    width: ${AUTH_PANEL_WIDTH_PX}px;
    max-width: ${AUTH_PANEL_WIDTH_PX}px;
    min-height: 100vh;
    overflow: hidden;
    background-color: ${AUTH_PANEL_BLUE};

    @media (max-width: ${AUTH_STACKED_LAYOUT_MAX_WIDTH_PX}px) {
        width: ${AUTH_PANEL_MOBILE_WIDTH_PX}px;
        max-width: ${AUTH_PANEL_MOBILE_WIDTH_PX}px;
    }
`;

export const PanelBackground = styled.div`
    position: absolute;
    inset: 0;
    background-image: url(${LOGIN_HERO_IMAGE});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    @media (max-width: ${AUTH_STACKED_LAYOUT_MAX_WIDTH_PX}px) {
        background-position: 68% center;
    }
`;

export const PanelContent = styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
    padding: 48px 40px;

    @media (max-width: ${AUTH_STACKED_LAYOUT_MAX_WIDTH_PX}px) {
        padding: 24px 16px;
    }
`;

export const LogoButton = styled.button`
    align-self: flex-start;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    text-align: left;
    max-width: 100%;
`;

export const LogoImage = styled.img`
    display: block;
    width: 105px;
    height: auto;
    max-width: 100%;

    @media (max-width: ${AUTH_STACKED_LAYOUT_MAX_WIDTH_PX}px) {
        width: 80px;
    }
`;

export const PanelTagline = styled.p`
    display: flex;
    align-items: center;
    margin: 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 37px;
    font-weight: 600;
    line-height: 44px;
    letter-spacing: -0.7px;
    color: ${AUTH_TAGLINE_WHITE};

    @media (max-width: ${AUTH_STACKED_LAYOUT_MAX_WIDTH_PX}px) {
        align-items: flex-start;
        font-size: 15px;
        line-height: 18px;
        letter-spacing: -0.2px;
    }
`;
